import { cross_en } from "@adgm/cross-i18n";

// 内部状态存储远程语言包数据
const remoteData: {
  en: Record<string, any>;
  zh: Record<string, any>;
} = {
  en: {},
  zh: {},
};

// TODO：和Web的i18nUtil命名冲突，暂改为i18nCrossUtil，后续需要在adgm-libs中统一web和app的i18n
const i18nCrossUtil = {
  /**
   * 获取英文（en）语言包数据
   * @returns 合并后的英文语言包数据（远程数据覆盖本地数据，暂供 APP 使用）
   */
  t: (): Record<string, any> => {
    // 默认使用英文，远程数据覆盖本地数据
    return { ...cross_en, ...remoteData.en };
  },

  /**
   * 更新远程语言包数据（暂时只给APP使用,后续其他子系统需要的话,在子系统内调用该方法即可）
   * @param language 语言类型
   * @param data 远程语言包数据
   */
  updateLanguageData: (language: keyof typeof remoteData, data: Record<string, any>): void => {
    remoteData[language] = { ...data };
  },
};

export { i18nCrossUtil };
